<template>
  <div class="text-end mb-3">
    <button
      class="btn btn-primary"
      title="Exportar para Excel"
      @click="exportToExcel"
    >
      Exportar para Excel
    </button>
  </div>
  <div class="card">
    <div class="table-responsive">
      <table
        class="table table-sm table-bordered table-striped"
        id="tableReport"
      >
        <thead class="bg-teal text-white text-center">
          <tr>
            <th>Item de despesa <br />(Natureza Orçamentária)</th>
            <th>Primeiro Trimestre</th>
            <th>Segundo Trimestre</th>
            <th>Terceiro Trimestre</th>
            <th>Quarto Trimestre</th>
            <th>Valor Total</th>
            <th>Bloqueado</th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="ccPai in reports.centrosCustos"
            :key="ccPai.codCCustoPai"
          >
            <tr>
              <td class="fs-lg" colspan="7">
                <strong>
                  {{ ccPai.codCCustoPai }} - {{ ccPai.nomeCCustoPai }}
                </strong>
              </td>
            </tr>
            <template
              v-for="ccFilho in ccPai.ccFilhos"
              :key="ccFilho.codCCustoFilho"
            >
              <template v-if="ccFilho.naturezasOrcamentarias">
                <tr>
                  <td colspan="7">
                    <strong>
                      {{ ccFilho.codCCustoFilho }} -
                      {{ ccFilho.nomeCCustoFilho }}
                    </strong>
                  </td>
                </tr>
                <tr
                  v-for="naturezaOrcamentaria in ccFilho.naturezasOrcamentarias"
                  :key="naturezaOrcamentaria.codTBOrcamento"
                >
                  <td class="fs-smxs">
                    {{ naturezaOrcamentaria.codTBOrcamento }} -
                    {{ naturezaOrcamentaria.nomeTBOrcamento }}
                  </td>
                  <td class="fs-smxs text-center">
                    {{
                      moneyToCurrencyBrNoSymbol(naturezaOrcamentaria.primeiro)
                    }}
                  </td>
                  <td class="fs-smxs text-center">
                    {{
                      moneyToCurrencyBrNoSymbol(naturezaOrcamentaria.segundo)
                    }}
                  </td>
                  <td class="fs-smxs text-center">
                    {{
                      moneyToCurrencyBrNoSymbol(naturezaOrcamentaria.terceiro)
                    }}
                  </td>
                  <td class="fs-smxs text-center">
                    {{ moneyToCurrencyBrNoSymbol(naturezaOrcamentaria.quarto) }}
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(naturezaOrcamentaria.totalAno)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    {{
                      moneyToCurrencyBrNoSymbol(
                        naturezaOrcamentaria.totalBloqueado,
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Total</strong></td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{ moneyToCurrencyBrNoSymbol(ccFilho.totais.primeiro) }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{ moneyToCurrencyBrNoSymbol(ccFilho.totais.segundo) }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{ moneyToCurrencyBrNoSymbol(ccFilho.totais.terceiro) }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{ moneyToCurrencyBrNoSymbol(ccFilho.totais.quarto) }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{ moneyToCurrencyBrNoSymbol(ccFilho.totais.totalAno) }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.totalBloqueado)
                      }}
                    </strong>
                  </td>
                </tr>
              </template>
            </template>
            <tr class="table-primary">
              <td>
                <strong>
                  Total do Centro de Custo ({{ ccPai.codCCustoPai }})
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.primeiro) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.segundo) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.terceiro) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.quarto) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.totalAno) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.totalBloqueado) }}
                </strong>
              </td>
            </tr>
          </template>
          <tr class="table-success">
            <td><strong>Total Geral</strong></td>
            <td class="fs-smxs text-center">
              <strong>
                {{ moneyToCurrencyBrNoSymbol(reports.totais.primeiro) }}
              </strong>
            </td>
            <td class="fs-smxs text-center">
              <strong>
                {{ moneyToCurrencyBrNoSymbol(reports.totais.segundo) }}
              </strong>
            </td>
            <td class="fs-smxs text-center">
              <strong>
                {{ moneyToCurrencyBrNoSymbol(reports.totais.terceiro) }}
              </strong>
            </td>
            <td class="fs-smxs text-center">
              <strong>
                {{ moneyToCurrencyBrNoSymbol(reports.totais.quarto) }}
              </strong>
            </td>
            <td class="fs-smxs text-center">
              <strong>
                {{ moneyToCurrencyBrNoSymbol(reports.totais.totalAno) }}
              </strong>
            </td>
            <td class="fs-smxs text-center">
              <strong>
                {{ moneyToCurrencyBrNoSymbol(reports.totais.totalBloqueado) }}
              </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { moneyToCurrencyBrNoSymbol } from '@/utils/strings'
import '@/assets/js/jquery.table2excel'

export default {
  name: 'TrimestralResult',

  props: {
    reports: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moneyToCurrencyBrNoSymbol,
    }
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    exportToExcel() {
      window.$('#tableReport').table2excel({
        name: 'Trimestral',
        filename: 'Relatorio_SGCC_Trimestral.xls',
      })
    },
  },
}
</script>

<style scoped>
td {
  padding: 0.3rem;
}
</style>
